import React, { useEffect, useRef } from 'react';
import {
  Divider,
  Dimmer,
  Header,
  Segment,
  Card,
  Button,
} from 'semantic-ui-react';

import { useTranslation } from 'react-i18next';

import { useDispatch, useSelector } from 'react-redux';

import firebase from '../../../config/fire';
import { resetActiveAccount, setActiveAccount } from '../../../modules/account';

import { loggedOut } from '../../../modules/user';
import { useHostAppProxy } from 'src/contexts/HostAppProxyContext';

const LAST_ACTIVE_ACCOUNT_KEY = 'br-laa';

const AccountSelector = () => {
  const { t } = useTranslation();
  const { signOut } = useHostAppProxy();
  const dispatch = useDispatch();
  const userProfile = useSelector((state: any) => state.user.userProfile);
  const activeAccount = useSelector(
    (state: any) => state.account.activeAccount
  );

  const restoredSavedAccount = useRef(false);

  useEffect(() => {
    const memberships = userProfile?.accountMembership || [];
    if (memberships.length === 0) {
      if (activeAccount) dispatch(resetActiveAccount());
      return;
    }
    const selectedId =
      activeAccount?._id ||
      (!restoredSavedAccount.current
        ? window.localStorage.getItem(LAST_ACTIVE_ACCOUNT_KEY)
        : undefined);
    restoredSavedAccount.current = true;
    const membership =
      memberships.find((item: any) => item.account._id === selectedId) ||
      (memberships.length === 1 ? memberships[0] : undefined);
    const account = membership?.account;
    if (account && account !== activeAccount) {
      window.localStorage.setItem(LAST_ACTIVE_ACCOUNT_KEY, account._id);
      dispatch(setActiveAccount({ account }));
    } else if (!account && activeAccount) {
      dispatch(resetActiveAccount());
    }
  }, [userProfile, activeAccount, dispatch]);

  const _setActiveAccount = (account: any) => {
    window.localStorage.setItem(LAST_ACTIVE_ACCOUNT_KEY, account._id);
    dispatch(setActiveAccount({ account }));
  };

  const handleSignout = () => {
    dispatch(resetActiveAccount());
    dispatch(loggedOut());
    signOut();
    firebase.auth().signOut();
  };

  if (
    !userProfile ||
    activeAccount ||
    !userProfile.accountMembership ||
    userProfile.accountMembership.length === 0
  ) {
    return null;
  }

  return (
    <Dimmer active>
      <Segment>
        <Header size="large">{t('Account')}</Header>
        <Card.Group itemsPerRow={1}>
          {userProfile.accountMembership.map((membership: any) => (
            <Card
              key={membership.account._id}
              onClick={() => _setActiveAccount(membership.account)}
              style={{ color: 'black' }}
            >
              <Card.Content
                textAlign="left"
                header={[
                  <span key="name">
                    {membership.account.owner.displayName}
                  </span>,
                ]}
                description={t(`member_role_${membership.role}`)}
              />
            </Card>
          ))}
        </Card.Group>
        <Divider hidden />
        <Button
          basic
          onClick={e => {
            e.preventDefault();
            handleSignout();
          }}
          icon="log out"
          content={t('SignOut')}
        />
      </Segment>
    </Dimmer>
  );
};

export default AccountSelector;
